module.exports = __webpack_public_path__ + "img/kin.bf6774aa.svg";